import { Component, Input } from "@angular/core";

@Component({
    templateUrl: './check-inbox.component.html',
    styleUrls: [
      '../../../core/Styles/AccountShared/account-styles.css',
      './check-inbox.component.css'
    ],
    selector: 'check-inbox'
})
export class CheckInboxComponent {

    @Input() public Email: string;

    public Message: string = ""

}
